/**
 * The various URI Particles.
 */
export const URIParticle = {
    APP: 'app',
    FACEBOOK: 'facebook',
    GLOBAL: 'global',
    TOP: 'top',
    USER: 'user',
    CONCERTS: 'concerts',
    HUB: 'hub',
};
//# sourceMappingURL=uri_particle.js.map